




import { defineComponent } from '@nuxtjs/composition-api';
import { DcwVideoListingLayout } from '@/components/Layouts';
import { CssVariables, PagesLinks, ProjectSelectors, VideoListingContent } from '@/types';
import { useLocales, usePage } from '@/composables';

export default defineComponent({
  components: { DcwVideoListingLayout },
  layout: 'Default',
  setup() {
    const { translation } = useLocales();

    usePage({
      data: {
        title: translation.pagesTitles.videoListing,
        description: translation.pagesDescription.videoListing
      },
      breadcrumbs: [
        { name: translation.pagesNames.home, url: PagesLinks.HOME },
        { name: translation.pagesNames.career, url: PagesLinks.CAREER },
        { name: translation.pagesTitles.videoListing, url: '' }
      ],
      styleSheet: [
        {
          selectors: [ProjectSelectors.HEADER],
          properties: [{ key: CssVariables.COLOR_BACKGROUND, value: `var(${CssVariables.COLOR_SKY_BLUE})` }]
        }
      ]
    });

    const layoutContent: VideoListingContent = {
      hero: translation.videoListing.hero,
      integrations: translation.videoListing.integrations,
      interviews: translation.videoListing.interviews
    };

    return { layoutContent };
  },
  nuxtI18n: {
    locales: ['en']
  },
  head: {}
});
